import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const notification = 'Notifications'

export const getNotificationsByProvider = (id) => {
  return axios.get(`/${notification}/${id}`)
}

export const markNotificationAsRead = (id) => {
  return axios.put(`/${notification}/${id}`)
}

export const markNotificationsAsRead = (providerId) => {
  return axios.put(`/${notification}/all/${providerId}`)
}

export const downloadDocument = (id) => {
  return axios.get(`/${notification}/Documents?id=${id}`)
}
